<form>
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.MonitorSoftwareComponent_Title }}</h2>
    </div>

    <div class="form-section" [hidden]="loading" *ngIf="!noDataError">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ReleaseDetails_Version }}:</label>
                    <div class="value">
                        <a (click)="openSoftware()">{{ releaseName }}</a> (version {{ releaseVersion }})
                    </div>
                </div>

                <div class="flex-row">
                    <label>{{ languageService.languageJSON.ReleaseDetails_TargetBikeComponent }}:</label>
                    <div class="value">
                        <a (click)="openComponent(componentName)">{{ componentName }}</a> ({{ componentClassName }})
                    </div>
                </div>

                <div class="flex-row">
                    <label>{{ languageService.languageJSON.MonitorSoftwareComponent_AffectedConfigurations }}:</label>
                    <div class="value">
                        <span *ngFor="let conifId of configIds; let i = index">
                            <a (click)="openConfiguration(conifId)">
                                <span>C{{conifId}} </span>
                            </a>
                            <span *ngIf="configNames.length>i && configNames[i]">({{configNames[i]}}) </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-section table" [hidden]="loading" *ngIf="!noDataError">
        <div class="rule-title">{{ languageService.languageJSON.MonitorSoftwareComponent_ApprovalRolloutHistory }}</div>
        <div class="flex-outer flex-column table">
            <div class="flex-row header">
                <div class="flex-col" [ngClass]="{'medium-col': index==1}"
                    *ngFor="let rolloutHistoryField of rolloutHistoryFields; let index = index;">
                    {{ rolloutHistoryField.DisplayName }}
                </div>
            </div>
            <ng-scrollbar [orientation]="'vertical'">
                <div class="flex-row"
                    *ngFor="let approvalRolloutElement of approvalRolloutHistoryList; let last = last;"
                    [ngClass]="{'no-border': last}">
                    <div class="flex-col" [ngClass]="{'medium-col': index==1}"
                        *ngFor="let rolloutHistoryField of rolloutHistoryFields; let index = index;">
                        <span
                            *ngIf="rolloutHistoryField.Id!=5 && rolloutHistoryField.Id!=6 && rolloutHistoryField.Id!=7 && rolloutHistoryField.Id!=9">
                            {{getValue(approvalRolloutElement, rolloutHistoryField.FieldName)}}<span *ngIf="rolloutHistoryField.Id==8 || 
                            rolloutHistoryField.Id==10">%</span></span>
                        <a *ngIf="rolloutHistoryField.Id==5 && isLinkValue(approvalRolloutElement, rolloutHistoryField.FieldName)"
                            (click)="openBikesDetails(approvalRolloutElement, 1)">{{
                            getValue(approvalRolloutElement, rolloutHistoryField.FieldName) }}</a>
                        <span
                            *ngIf="rolloutHistoryField.Id==5 && !isLinkValue(approvalRolloutElement, rolloutHistoryField.FieldName)">0</span>
                        <a *ngIf="rolloutHistoryField.Id==6 && isLinkValue(approvalRolloutElement, rolloutHistoryField.FieldName)"
                            (click)="openDeliveriesDetails(approvalRolloutElement, 1)">{{
                            getValue(approvalRolloutElement, rolloutHistoryField.FieldName) }}</a>
                        <span
                            *ngIf="rolloutHistoryField.Id==6 && !isLinkValue(approvalRolloutElement, rolloutHistoryField.FieldName)">0</span>
                        <a *ngIf="rolloutHistoryField.Id==7 && isLinkValue(approvalRolloutElement, rolloutHistoryField.FieldName)"
                            (click)="openSuccessDetails(approvalRolloutElement, 1)">{{
                            getValue(approvalRolloutElement, rolloutHistoryField.FieldName) }}</a>
                        <span
                            *ngIf="rolloutHistoryField.Id==7 && !isLinkValue(approvalRolloutElement, rolloutHistoryField.FieldName)">0</span>
                        <a *ngIf="rolloutHistoryField.Id==9 && isLinkValue(approvalRolloutElement, rolloutHistoryField.FieldName)"
                            (click)="openErrorsDetails(approvalRolloutElement, 1)">{{
                            getValue(approvalRolloutElement, rolloutHistoryField.FieldName) }}</a>
                        <span
                            *ngIf="rolloutHistoryField.Id==9 && !isLinkValue(approvalRolloutElement, rolloutHistoryField.FieldName)">0</span>
                    </div>
                </div>
                <div class="flex-row no-border" *ngIf="approvalRolloutHistoryList.length==0 && !loading">
                    <div class="flex-col">{{ languageService.languageJSON.Global_NoItems }}</div>
                </div>
            </ng-scrollbar>
        </div>
    </div>

    <div class="chart" *ngIf="!loading && approvalRolloutHistoryList?.length!=0 && approvalBarChartShow">
        <canvas baseChart [options]="barChartOptions" [type]="barChartType" [data]="approvalBarChartData">
        </canvas>
    </div>

    <div class="form-section table" [hidden]="loading" *ngIf="!noDataError">
        <div class="rule-title">{{ languageService.languageJSON.MonitorSoftwareComponent_ApprovalHistory }}</div>
        <div class="flex-outer flex-column table">
            <div class="flex-row header">
                <div class="flex-col" [ngClass]="{'medium-col': index==1}"
                    *ngFor="let rolloutHistoryField of rolloutHistoryFields; let index = index;">
                    {{ rolloutHistoryField.DisplayName }}
                </div>
            </div>
            <ng-scrollbar [orientation]="'vertical'">
                <div class="flex-row" *ngFor="let rolloutElement of rolloutHistoryList; let last = last;"
                    [ngClass]="{'no-border': last}">
                    <div class="flex-col" [ngClass]="{'medium-col': index==1}"
                        *ngFor="let rolloutHistoryField of rolloutHistoryFields; let index = index;">
                        <span
                            *ngIf="rolloutHistoryField.Id!=5 && rolloutHistoryField.Id!=6 && rolloutHistoryField.Id!=7 && rolloutHistoryField.Id!=9">
                            {{ getValue(rolloutElement, rolloutHistoryField.FieldName) }}<span *ngIf="rolloutHistoryField.Id==8 || 
                            rolloutHistoryField.Id==10">%</span></span>
                        <a *ngIf="rolloutHistoryField.Id==5 && isLinkValue(rolloutElement, rolloutHistoryField.FieldName)"
                            (click)="openBikesDetails(rolloutElement, 0)">{{
                            getValue(rolloutElement, rolloutHistoryField.FieldName) }}</a>
                        <span
                            *ngIf="rolloutHistoryField.Id==5 && !isLinkValue(rolloutElement, rolloutHistoryField.FieldName)">0</span>
                        <a *ngIf="rolloutHistoryField.Id==6 && isLinkValue(rolloutElement, rolloutHistoryField.FieldName)"
                            (click)="openDeliveriesDetails(rolloutElement, 0)">{{
                            getValue(rolloutElement, rolloutHistoryField.FieldName) }}</a>
                        <span
                            *ngIf="rolloutHistoryField.Id==6 && !isLinkValue(rolloutElement, rolloutHistoryField.FieldName)">0</span>
                        <a *ngIf="rolloutHistoryField.Id==7 && isLinkValue(rolloutElement, rolloutHistoryField.FieldName)"
                            (click)="openSuccessDetails(rolloutElement, 0)">{{
                            getValue(rolloutElement, rolloutHistoryField.FieldName) }}</a>
                        <span
                            *ngIf="rolloutHistoryField.Id==7 && !isLinkValue(rolloutElement, rolloutHistoryField.FieldName)">0</span>
                        <a *ngIf="rolloutHistoryField.Id==9 && isLinkValue(rolloutElement, rolloutHistoryField.FieldName)"
                            (click)="openErrorsDetails(rolloutElement, 0)">{{
                            getValue(rolloutElement, rolloutHistoryField.FieldName) }}</a>
                        <span
                            *ngIf="rolloutHistoryField.Id==9 && !isLinkValue(rolloutElement, rolloutHistoryField.FieldName)">0</span>
                    </div>
                </div>
                <div class="flex-row no-border" *ngIf="rolloutHistoryList.length==0 && !loading">
                    <div class="flex-col">{{ languageService.languageJSON.Global_NoItems }}</div>
                </div>
            </ng-scrollbar>
        </div>
    </div>

    <div class="chart" *ngIf="!loading && rolloutHistoryList?.length!=0 && rolloutBarChartShow">
        <canvas baseChart [options]="barChartOptions" [type]="barChartType" [data]="rolloutBarChartData">
        </canvas>
    </div>

    <div class="form-section" [hidden]="loading" *ngIf="noDataError">
        <div class="flex-outer">
            <div class="flex-col">
                <div class="flex-row">
                    <label class="error-label">{{ noDataString }}</label>
                </div>
            </div>
        </div>
    </div>

    <app-loading-animation class="edit-animation" *ngIf="loading"></app-loading-animation>
</form>